import axios from "axios";
import { API_URL } from "../config";

export default class {
    static getAll = async (token) => {
        let result = { data: null, error: null };
        await axios.get(`${API_URL}/wanted/all-admin`, {
            headers: { alshorja_auth: token }
        }).then(res => {
            result.data = res.data;
        }).catch(err => {
            result.error = err.response ? err.response.data : (err.message || "Server Error");
        });
        return result;
    }

    static delete = async (token, id) => {
        let result = { data: null, error: null };
        await axios.delete(`${API_URL}/wanted/${id}`, {
            headers: { alshorja_auth: token }
        }).then(res => {
            result.data = res.data;
        }).catch(err => {
            result.error = err.response ? err.response.data : (err.message || "Server Error");
        });
        return result;
    }
}
